<div class="theme-builder-inner">
	<form #kvForm="ngForm" name="kvForm" class="theme-form form-signin" [ngClass]="{ 'disabled-form': !themeReady }">
		<h3>{{LOCALIZATION.themeBuilder}}</h3>
		<div class="form-content">
			<div class="row">
				<div class="col-md-4">
					<button class="btn btn-primary btn-sm" (click)="newTheme()">{{LOCALIZATION.new}}</button>
				</div>				
			</div>
			<div class="form-user-input-content" [ngClass]="{ 'disabled-form': !themeReady }">
				<div class="row">
					<div class="col-md-8">
						<label for="theme">{{LOCALIZATION.themeCurrent}}</label> 					
						<select id="theme" name="theme" class="form-control" [(ngModel)]="theme" (change)="loadTheme()">
						  <option *ngFor="let theme of themes" [ngValue]="theme">{{ theme.label }}</option>
						</select>
					</div>
<!-- 					<div class="col-md-4"> -->
<!-- 						<button class="btn btn-primary btn-sm" (click)="loadTheme()" [disabled]="!!theme['id']">{{LOCALIZATION.apply}}</button> -->
<!-- 					</div>					 -->
				</div>
		        <div class="row">
		            <div class="col-md-8">
		                <label for="enabled">{{LOCALIZATION.enable}}</label>
		                <div class="toggle-switch">
		                    <input id="enabled" name="enabled" class="toggle-switch-toggle toggle-switch-toggle-round" type="checkbox" [(ngModel)]="theme['enabled']" />
		                    <label for="enabled"></label>
		                </div>
		            </div>
		        </div>
		        <div class="row">
		            <div class="col-md-12">
		                <label for="label">{{LOCALIZATION.title}}</label>
		                <input id="label" name="label" class="form-control item-input" type="text" [(ngModel)]="theme['label']" />
		            </div>
		        </div>
		        <div class="row">
		            <div class="col-md-12">
		                <label for="name">{{LOCALIZATION.name}}</label>
		                <input id="name" name="name" class="form-control item-input" type="text" [(ngModel)]="theme['name']" [readonly]="!!theme['id']" />
		            </div>
		        </div>
		        
		        <div *ngFor="let group of theme.variables | groupByKey: 'type'" class="form-section">
		        	<div class="section-title">{{ group.key | titlecase }}</div>
		        	
					<div *ngFor="let v of group.values" class="row">
						<div class="col-md-12">
							  <label [for]="v.name">{{ v.label }}</label>
							
							  <input
							    class="form-control item-input"
							    [id]="v.name"
							    [name]="v.name"
							    [type]="v.type === 'color' ? 'color' : 'text'"
							    [ngModel]="v.value"
							    (ngModelChange)="previewVariable(v, $event)"
							    (blur)="commitVariable(v, $event)"
							    [attr.data-type]="v.type"
							    [placeholder]="v.value" />
						</div>
					</div>	        	
		        </div>
	        </div>
			<div class="form-footer">
				<button class="btn btn-default" (click)="close()">{{LOCALIZATION.cancel}}</button>
			    <button class="btn btn-primary" (click)="save()" [disabled]="inprogress" *ngIf="userPermissions['ROLE_INTERFACE_CUSTOMIZE']">
			    	<i class="fas fa-spinner fa-spin fa-fw" [hidden]="!inprogress"></i>
			    	{{LOCALIZATION.save}}
			    </button>
			</div>	
		</div>
	</form>
</div>